import { useCallback } from 'react';

import { BaseRunsTableProps, RunsTable } from '.';
import { GridTimeModel, useDataGridState } from '../../hooks/useDataGridState';
import { useDebouncedFilter } from './hooks/useDebouncedFilter';
import { useSearchModel } from './hooks/useSearchModel';

export function UncontrolledRunsTable({
  defaultTimeModel,
  defaultColumnVisibility,
  runTableSessionId,
  ...props
}: BaseRunsTableProps & {
  defaultTimeModel?: GridTimeModel;
  navigateToRun?: (
    runId: string,
    sessionId?: string,
    trace_id?: string,
    root_start_time?: string
  ) => void;
  runTableSessionId?: string;
}) {
  const {
    searchModel,
    setSearchModel: _setSearchModel,
    updateSearchParams,
  } = useSearchModel();
  const {
    sortModel,
    columnVisibilityModel,
    paginationModel,
    filterModel,
    setSortModel,
    setColumnVisibilityModel,
    onColumnVisibilityResetClick,
    setPaginationModel,
    resetPaginationModel,
    setFilterModel,
    timeModel,
    setTimeModel,
    initialState,
  } = useDataGridState({
    defaultTimeModel,
    defaultColumnVisibility,
    updateSearchParams,
  });
  const setSearchModel: typeof _setSearchModel = useCallback(
    (arg) => {
      resetPaginationModel();
      return _setSearchModel(arg);
    },
    [resetPaginationModel, _setSearchModel]
  );
  const debouncedRunsFilter = useDebouncedFilter({
    runsFilter: props.runsFilter,
    timeModel,
    searchModel,
  });

  return (
    <RunsTable
      {...props}
      debouncedRunsFilter={debouncedRunsFilter}
      searchModel={searchModel}
      setSearchModel={setSearchModel}
      sortModel={sortModel}
      columnVisibilityModel={columnVisibilityModel}
      paginationModel={paginationModel}
      filterModel={filterModel}
      setSortModel={setSortModel}
      setColumnVisibilityModel={setColumnVisibilityModel}
      onColumnVisibilityResetClick={onColumnVisibilityResetClick}
      setPaginationModel={setPaginationModel}
      resetPaginationModel={resetPaginationModel}
      setFilterModel={setFilterModel}
      timeModel={timeModel}
      setTimeModel={setTimeModel}
      initialState={initialState}
      navigateToRun={props.navigateToRun}
      runTableSessionId={runTableSessionId}
    />
  );
}
